/* eslint-disable max-len */
const React = require('react');

const HomeNonDeveloperBanner = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="159"
    height="143"
    fill="none"
    viewBox="0 0 159 143"
  >
    <g>
      <g>
        <path
          fill="#000"
          fillOpacity="0.04"
          fillRule="evenodd"
          d="M144.572 41.008c-8.894-10.112-22.778-18.218-36.52-17.868-15.085.38-25.788-.864-37.213-6.474C59.927 11.31 42.909-2.771 24.537.482 1.66 4.53-6.126 28.426-.236 53.626c6.58 28.162 29.618 69.474 69.884 84.101 39.371 14.3 69.67-6.591 80.378-25.615 14.847-26.376 6.717-57.267-5.454-71.103z"
          clipRule="evenodd"
        />
      </g>
      <g>
        <g>
          <g>
            <g>
              <g>
                <g>
                  <mask id="path-2-inside-1" fill="#fff">
                    <path
                      fillRule="evenodd"
                      d="M20.846 15.493c2.558-5.241 7.018-9.346 12.957-10.197 6.556-.938 13.09 1.286 17.075 6.7 3.547 4.818 3 10.614 3.646 16.232.64 5.572 2.706 10.68 5.646 15.446C66.436 53.833 82.4 59.476 80.98 79.229c-1.655 11.965-6.03 21.221-23.293 22.914-25.875 2.538-35.854-24.97-39.457-45.579-2.45-14.015-2.915-29.736 2.616-41.071z"
                      clipRule="evenodd"
                    />
                  </mask>
                  <path
                    fill="#5AD2FF"
                    fillRule="evenodd"
                    stroke="#fff"
                    strokeWidth="6"
                    d="M20.846 15.493c2.558-5.241 7.018-9.346 12.957-10.197 6.556-.938 13.09 1.286 17.075 6.7 3.547 4.818 3 10.614 3.646 16.232.64 5.572 2.706 10.68 5.646 15.446C66.436 53.833 82.4 59.476 80.98 79.229c-1.655 11.965-6.03 21.221-23.293 22.914-25.875 2.538-35.854-24.97-39.457-45.579-2.45-14.015-2.915-29.736 2.616-41.071z"
                    clipRule="evenodd"
                    mask="url(#path-2-inside-1)"
                  />
                </g>
                <path
                  fillRule="evenodd"
                  stroke="#333"
                  d="M20.846 15.493c2.558-5.241 7.018-9.346 12.957-10.197 6.556-.938 13.09 1.286 17.075 6.7 3.547 4.818 3 10.614 3.646 16.232.64 5.572 2.706 10.68 5.646 15.446C66.436 53.833 82.4 59.476 80.98 79.229c-1.655 11.965-6.03 21.221-23.293 22.914-25.875 2.538-35.854-24.97-39.457-45.579-2.45-14.015-2.915-29.736 2.616-41.071z"
                  clipRule="evenodd"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <path
                fill="#fff"
                fillRule="evenodd"
                d="M25.925 52.316s1.904-2.375 2.948-4.75c1.045-2.376 2.519-15.522 2.519-15.522l3.952-2.825 8.108 7.289s-.695 14.743.165 15.89c.86 1.146 1.883 1.638 1.883 1.638l2.048 4.996-11.14 3.604-9.664-4.668-.82-5.652z"
                clipRule="evenodd"
              />
              <path
                fillRule="evenodd"
                stroke="#333"
                strokeWidth="1.5"
                d="M25.925 52.316s1.904-2.375 2.948-4.75c1.045-2.376 2.519-15.522 2.519-15.522l3.952-2.825 8.108 7.289s-.695 14.743.165 15.89c.86 1.146 1.883 1.638 1.883 1.638l2.048 4.996-11.14 3.604-9.664-4.668-.82-5.652z"
                clipRule="evenodd"
              />
              <path
                fill="#fff"
                fillRule="evenodd"
                d="M65.602 85.675c-2.369.412-4.417.795-4.417.795-.016.002-.022-.02-.007-.025 0 0 2.082-.85 4.423-1.833a800.893 800.893 0 00-.014-3.248c-2.628.772-5.268 1.57-5.785 1.73-.015.005-.023-.016-.01-.022.663-.294 3.286-1.47 5.788-2.657-.008-1.052-.02-2.046-.033-2.969-4.387 1.376-10.52 3.53-11.365 4.11-1.31.901-8.354 7.126-10.074 8.723-.966.897-9.94 6.14-19.166 9.829-7.21 2.882-14.83 4.313-17.2 5.283-2.855 1.167-6.36 3.467-9.034 6.426.692.61 1.387 1.215 2.095 1.806 1.56 1.301 3.172 2.546 4.865 3.67.835.555 1.69 1.08 2.567 1.565.451.25.908.49 1.372.718.398.196.795.393 1.224.516a4.635 4.635 0 003.428-.353c-.009-.069-.011-.139-.022-.208a3.757 3.757 0 00-.29-1.026c-.012-.025.028-.044.04-.019.034.073.065.148.093.225.118.323.182.663.223 1.004.453-.248.866-.57 1.202-.986.017-.022.053.003.036.025-.13.159-.269.31-.42.449a3.996 3.996 0 01-.81.564c0 .009.003.019.004.029.045.415.054.836.04 1.254-.027.83-.135 1.659-.313 2.469-.08.367-.174.733-.317 1.081-.159.388-.367.754-.598 1.102-.5.754-1.107 1.429-1.706 2.104l-.102.114c1.966-.824 4.055-1.998 6.251-3.609 6.02-4.915 31.616-26.62 31.616-26.62s7.044-.654 10.935-4.259c1.35-1.25 2.954-2.717 4.811-3.706.223-.118.446-.232.67-.344.001-1.267.002-2.507 0-3.707z"
                clipRule="evenodd"
              />
              <g fill="#fff">
                <mask id="path-7-inside-2">
                  <path
                    fillRule="evenodd"
                    d="M25.925 52.316s-8.518 3.604-13.269 6.143c-4.75 2.539-10.484 7.126-13.269 12.04C-3.397 75.414-6.183 89.338-7 94.415c-.82 5.078-.983 12.204-.983 12.204s-4.177 4.669-4.423 9.829c-.246 5.16 3.317 11.548 7.617 11.548h70.03s.818-53.73 0-57.497c-.82-3.768-3.44-7.372-8.355-10.32-4.505-2.703-10.662-6.025-11.656-6.56a.096.096 0 00-.143.078c-.052.723-.613 3.794-6.384 4.516-6.552.82-12.777-5.897-12.777-5.897z"
                    clipRule="evenodd"
                  />
                </mask>
                <path
                  fillRule="evenodd"
                  stroke="#fff"
                  strokeWidth="6"
                  d="M25.925 52.316s-8.518 3.604-13.269 6.143c-4.75 2.539-10.484 7.126-13.269 12.04C-3.397 75.414-6.183 89.338-7 94.415c-.82 5.078-.983 12.204-.983 12.204s-4.177 4.669-4.423 9.829c-.246 5.16 3.317 11.548 7.617 11.548h70.03s.818-53.73 0-57.497c-.82-3.768-3.44-7.372-8.355-10.32-4.505-2.703-10.662-6.025-11.656-6.56a.096.096 0 00-.143.078c-.052.723-.613 3.794-6.384 4.516-6.552.82-12.777-5.897-12.777-5.897z"
                  clipRule="evenodd"
                  mask="url(#path-7-inside-2)"
                />
              </g>
              <path
                fillRule="evenodd"
                stroke="#333"
                d="M25.925 52.316s-8.518 3.604-13.269 6.143c-4.75 2.539-10.484 7.126-13.269 12.04C-3.397 75.414-6.183 89.338-7 94.415c-.82 5.078-.983 12.204-.983 12.204s-4.177 4.669-4.423 9.829c-.246 5.16 3.317 11.548 7.617 11.548h70.03s.818-53.73 0-57.497c-.82-3.768-3.44-7.372-8.355-10.32-4.505-2.703-10.662-6.025-11.656-6.56a.096.096 0 00-.143.078c-.052.723-.613 3.794-6.384 4.516-6.552.82-12.777-5.897-12.777-5.897z"
                clipRule="evenodd"
              />
              <g>
                <g>
                  <g>
                    <mask id="path-9-inside-3" fill="#fff">
                      <path
                        fillRule="evenodd"
                        d="M63.31 93.192l24.996 2.464c1.657.18 3.18-1.075 3.36-2.733L94.98 59.73c.18-1.657-1.075-3.18-2.732-3.36l-24.996-2.463c-1.658-.18-3.18 1.075-3.36 2.732l-3.315 33.194c-.179 1.702 1.075 3.18 2.733 3.36z"
                        clipRule="evenodd"
                      />
                    </mask>
                    <path
                      fill="#5AD2FF"
                      fillRule="evenodd"
                      stroke="#fff"
                      strokeWidth="6"
                      d="M63.31 93.192l24.996 2.464c1.657.18 3.18-1.075 3.36-2.733L94.98 59.73c.18-1.657-1.075-3.18-2.732-3.36l-24.996-2.463c-1.658-.18-3.18 1.075-3.36 2.732l-3.315 33.194c-.179 1.702 1.075 3.18 2.733 3.36z"
                      clipRule="evenodd"
                      mask="url(#path-9-inside-3)"
                    />
                  </g>
                  <path
                    fillRule="evenodd"
                    stroke="#333"
                    d="M63.31 93.192l24.996 2.464c1.657.18 3.18-1.075 3.36-2.733L94.98 59.73c.18-1.657-1.075-3.18-2.732-3.36l-24.996-2.463c-1.658-.18-3.18 1.075-3.36 2.732l-3.315 33.194c-.179 1.702 1.075 3.18 2.733 3.36z"
                    clipRule="evenodd"
                  />
                  <ellipse
                    cx="77.689"
                    cy="74.333"
                    fill="#fff"
                    stroke="#333"
                    rx="2.688"
                    ry="2.688"
                  />
                </g>
              </g>
              <g>
                <g>
                  <g>
                    <path
                      fill="#fff"
                      fillRule="evenodd"
                      stroke="#333"
                      d="M42.993 93.71l-.15.338-4.594 10.422a.6.6 0 00.561.836H67.401a.611.611 0 00.56-.361l9.073-20.584H47.113l-1.32 2.992-2.8 6.356z"
                      clipRule="evenodd"
                    />
                    <path
                      fill="#EEE"
                      fillRule="evenodd"
                      d="M47.362 84.798l-2.618 6.109 2.618 13.963 3.055.872-3.055-20.944z"
                      clipRule="evenodd"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <path
                      fill="#fff"
                      fillRule="evenodd"
                      stroke="#333"
                      d="M47.362 107.052V84.361H91.87v43.635H48.362a1 1 0 01-1-1v-19.944z"
                      clipRule="evenodd"
                    />
                    <path
                      fill="#fff"
                      fillRule="evenodd"
                      stroke="#333"
                      d="M121.542 84.361H91.869v43.635h28.673a1 1 0 001-1V84.361z"
                      clipRule="evenodd"
                    />
                    <path
                      fill="#EEE"
                      fillRule="evenodd"
                      d="M121.248 91.166l-1.637-3.793-22.365-2.729H92.22v6.986l7.165 16.136a.594.594 0 00.543.357h21.32V91.166z"
                      clipRule="evenodd"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <g>
                      <path
                        fill="#fff"
                        fillRule="evenodd"
                        d="M130.093 105.306h-28.59a.613.613 0 01-.561-.361L91.87 84.361h29.921l8.863 20.109a.6.6 0 01-.561.836z"
                        clipRule="evenodd"
                      />
                      <path
                        stroke="#333"
                        d="M130.093 105.306h-28.59a.613.613 0 01-.561-.361L91.87 84.361h29.921l8.863 20.109a.6.6 0 01-.561.836"
                      />
                    </g>
                  </g>
                  <g>
                    <path
                      fill="#5AD2FF"
                      stroke="#fff"
                      strokeWidth="3"
                      d="M62.617 121.753H71.572V126.664H62.617z"
                      transform="rotate(-180 62.617 121.753)"
                    />
                    <path
                      stroke="#333"
                      strokeWidth="1.5"
                      d="M64.117 123.253H76.072V131.164H64.117z"
                      transform="rotate(-180 64.117 123.253)"
                    />
                  </g>
                  <g>
                    <g>
                      <mask id="path-21-inside-4" fill="#fff">
                        <path
                          fillRule="evenodd"
                          d="M75.288 84.361V96.58l-2.886-2.895-3.032 2.895-2.88-2.895-2.983 2.895V84.361H75.29z"
                          clipRule="evenodd"
                        />
                      </mask>
                      <path
                        fill="#5AD2FF"
                        fillRule="evenodd"
                        stroke="#fff"
                        strokeWidth="6"
                        d="M75.288 84.361V96.58l-2.886-2.895-3.032 2.895-2.88-2.895-2.983 2.895V84.361H75.29z"
                        clipRule="evenodd"
                        mask="url(#path-21-inside-4)"
                      />
                    </g>
                    <path
                      fillRule="evenodd"
                      stroke="#333"
                      d="M75.288 84.361V96.58l-2.886-2.895-3.032 2.895-2.88-2.895-2.983 2.895V84.361H75.29z"
                      clipRule="evenodd"
                    />
                  </g>
                  <g
                    fillRule="evenodd"
                    stroke="#333"
                    strokeWidth="1.5"
                    clipRule="evenodd"
                  >
                    <path d="M110.197 118.833h3.054v-3.055h-3.054v3.055z" />
                    <path d="M110.197 124.069h3.054v-3.054h-3.054v3.054z" />
                    <path d="M118.051 118.833H114.996v-3.055h3.055v3.055z" />
                    <path d="M116.179 122.197h-1.183v-1.182h1.183v1.182z" />
                    <path d="M118.051 124.069h-1.224v-1.224h1.224v1.224z" />
                  </g>
                </g>
              </g>
              <path
                stroke="#333"
                d="M11.305 75.29c1.842 2.95 2.825 7.618 2.825 7.618s-.368 15.234-.983 20.517L9.34 105.39l-2.703-1.965s-2.826-.86-5.529-1.106c-2.703-.245-4.545.737-4.545.737"
              />
              <path
                stroke="#333"
                strokeWidth="1.5"
                d="M14.294 120.298s.082 3.194-.819 4.914c-.9 1.72-2.621 2.867-2.621 2.867"
              />
              <path
                fill="#fff"
                fillRule="evenodd"
                d="M57.172 90.975c-3.89 3.604-10.935 4.26-10.935 4.26s-25.595 21.704-31.615 26.619c-13.391 9.828-22.975 3.808-22.975-3.318 0-7.125 7.74-13.391 13.146-15.602 2.371-.97 9.991-2.401 17.2-5.283 9.226-3.689 18.2-8.932 19.166-9.83 1.72-1.596 8.764-7.82 10.074-8.722 1.311-.9 15.358-5.59 15.85-5.283.49.307.86.737.613 1.413-.224.618-9.517 4.793-10.852 5.385-.014.007-.006.027.01.023 1.059-.329 11.047-3.34 11.539-3.299.491.041 1.064 1.393.696 1.884-.368.491-10.86 4.765-10.86 4.765-.014.006-.008.028.007.026 0 0 10.935-2.047 11.508-1.76.574.286.246 1.514-.204 1.924-.294.268-4.063 1.233-7.556 3.092-1.858.988-3.462 2.455-4.812 3.706z"
                clipRule="evenodd"
              />
              <path
                fill="#fff"
                fillRule="evenodd"
                d="M62.013 79.162c.477-.148 2.765-.84 5.18-1.552-1.177.313-3.046.853-4.881 1.393l-.308.137c-.014.006-.006.027.01.022z"
                clipRule="evenodd"
              />
              <path
                fill="#fff"
                fillRule="evenodd"
                d="M-3.193 117.062c0-7.125 7.74-13.391 13.146-15.603l.13-.05c-2.401.636-4.302 1.12-5.29 1.525-5.405 2.211-13.146 8.477-13.146 15.603 0 5.992 6.78 11.2 16.9 6.859-7.198.952-11.74-3.428-11.74-8.334z"
                clipRule="evenodd"
              />
              <path
                fill="#fff"
                fillRule="evenodd"
                d="M52.99 93.527c-.971.175-1.593.233-1.593.233l-.653.555a22.885 22.885 0 002.246-.788z"
                clipRule="evenodd"
              />
              <path
                fillRule="evenodd"
                stroke="#333"
                d="M57.172 90.975c-3.89 3.604-10.935 4.26-10.935 4.26s-25.595 21.704-31.615 26.619c-13.391 9.828-22.975 3.808-22.975-3.318 0-7.125 7.74-13.391 13.146-15.602 2.371-.97 9.991-2.401 17.2-5.283 9.226-3.689 18.2-8.932 19.166-9.83 1.72-1.596 8.764-7.82 10.074-8.722 1.311-.9 15.358-5.59 15.85-5.283.49.307.86.737.613 1.413-.224.618-9.517 4.793-10.852 5.385-.014.007-.006.027.01.023 1.059-.329 11.047-3.34 11.539-3.299.491.041 1.064 1.393.696 1.884-.368.491-10.86 4.765-10.86 4.765-.014.006-.008.028.007.026 0 0 10.935-2.047 11.508-1.76.574.286.246 1.514-.204 1.924-.294.268-4.063 1.233-7.556 3.092-1.858.988-3.462 2.455-4.812 3.706z"
                clipRule="evenodd"
              />
            </g>
            <path
              stroke="#333"
              strokeLinecap="square"
              d="M-34.782 127.996h177.158"
            />
          </g>
          <g>
            <g>
              <g>
                <path
                  fill="#fff"
                  fillRule="evenodd"
                  d="M24.558 28.345c-.457-.348-1.155-.726-1.853-.51-1.187.37-1.187 3.646-.573 5.12.614 1.474 2.334 2.62 2.907 2.62"
                  clipRule="evenodd"
                />
                <g>
                  <path
                    fill="#fff"
                    fillRule="evenodd"
                    d="M48.611 28.345c.421-.348 1.065-.726 1.708-.51 1.095.37 1.095 3.646.529 5.12-.566 1.474-2.152 2.62-2.68 2.62"
                    clipRule="evenodd"
                  />
                  <path
                    stroke="#333"
                    d="M48.611 28.345c.421-.348 1.065-.726 1.708-.51 1.095.37 1.095 3.646.529 5.12-.566 1.474-2.152 2.62-2.68 2.62"
                  />
                </g>
                <g>
                  <path
                    stroke="#333"
                    d="M24.558 28.345c-.457-.348-1.155-.726-1.853-.51-1.187.37-1.187 3.646-.573 5.12.614 1.474 2.334 2.62 2.907 2.62"
                  />
                </g>
                <path
                  fill="#fff"
                  fillRule="evenodd"
                  d="M24.355 26.51l.63 9.66a9.168 9.168 0 002.318 5.45c2.584 2.877 6.927 7.279 9.305 7.279 2.368 0 6.682-4.367 9.267-7.245a9.161 9.161 0 002.322-5.532l.572-9.612s.807-14.44-12.239-14.44c-13.046 0-12.175 14.44-12.175 14.44z"
                  clipRule="evenodd"
                />
                <path
                  fillRule="evenodd"
                  stroke="#333"
                  d="M24.355 26.51l.63 9.66a9.168 9.168 0 002.318 5.45c2.584 2.877 6.927 7.279 9.305 7.279 2.368 0 6.682-4.367 9.267-7.245a9.161 9.161 0 002.322-5.532l.572-9.612s.807-14.44-12.239-14.44c-13.046 0-12.175 14.44-12.175 14.44z"
                  clipRule="evenodd"
                />
              </g>
              <g>
                <g>
                  <g>
                    <g>
                      <path
                        fill="#5AD2FF"
                        fillRule="evenodd"
                        d="M25.38 11.35c-4.777 4.484-5.626 12.869-5.355 15.508 0 1.954.814 3.18.892 2.938 0 0 3.673-.492 6.895-3.624 2.842-2.369 4.357-9.017 4.357-9.017s4.737 6.158 10.42 7.105c4.489.748 7.035 1.301 8.974 2.355.083-3.209-.022-6.183-.447-7.882-1.052-4.207-4.042-9.288-8.987-10.936-4.906-1.635-11.223-1.635-16.75 3.553z"
                        clipRule="evenodd"
                      />
                      <mask
                        width="33"
                        height="24"
                        x="19"
                        y="6"
                        maskUnits="userSpaceOnUse"
                      >
                        <path
                          fill="#fff"
                          fillRule="evenodd"
                          d="M25.38 11.35c-4.777 4.484-5.626 12.869-5.355 15.508 0 1.954.814 3.18.892 2.938 0 0 3.673-.492 6.895-3.624 2.842-2.369 4.357-9.017 4.357-9.017s4.737 6.158 10.42 7.105c4.489.748 7.035 1.301 8.974 2.355.083-3.209-.022-6.183-.447-7.882-1.052-4.207-4.042-9.288-8.987-10.936-4.906-1.635-11.223-1.635-16.75 3.553z"
                          clipRule="evenodd"
                        />
                      </mask>
                    </g>
                  </g>
                  <path
                    stroke="#333"
                    strokeWidth="1.5"
                    d="M20.684 29.796s3.039-.197 6.682-3.115c3.642-2.918 4.847-9.483 4.93-9.402 2.766 3.353 6.474 6.108 10.294 6.981 4.17.953 6.11 1.301 8.973 2.355"
                  />
                  <path
                    style={{ mixBlendMode: 'multiply' }}
                    fill="#EEE"
                    fillRule="evenodd"
                    d="M20.684 29.796s3.039-.197 6.682-3.115c3.642-2.918 4.847-9.483 4.93-9.402 2.766 3.353 6.474 6.108 10.294 6.981 4.17.953 6.11 1.301 8.973 2.355 0 0-6.047.668-11.215-1.084-5.167-1.751-7.242-5.171-7.242-5.171s-1.22 5.082-3.604 6.892c-2.383 1.81-8.818 2.544-8.818 2.544z"
                    clipRule="evenodd"
                  />
                </g>
              </g>
              <g>
                <path
                  stroke="#333"
                  strokeWidth="1.5"
                  d="M33.07 36.561c.243 1.417 1.407 2.125 3.491 2.125 2.085 0 3.248-.727 3.491-2.181"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

module.exports = HomeNonDeveloperBanner;
